import React from 'react';
import Schema from '../../Schema/Schema';
const BreadcrumbSchema = (props: { items: any }) => {
	const { items } = props;
	return (
		<Schema
			schema={{
				'@context': 'http://schema.org',
				'@type': 'BreadcrumbList',
				itemListElement: [
					...items.map((item: any, index: number) => ({
						'@type': 'ListItem',
						position: `${index + 1}`,
						...item,
					})),
				],
			}}
		/>
	);
};

export default BreadcrumbSchema;
